import { Box, Divider } from "@mui/material"
import type { FC } from "react"
import { Fragment } from "react"
import { useFieldArray, useFormContext } from "react-hook-form"

import { SalesOrderLine } from "./SalesOrderLine"
import { SalesOrderTotals } from "./SalesOrderTotals"

import type { SalesOrder } from "@/graphql/codegen/graphql"
import type { SalesOrderLogisticsFormValues } from "@/screens/CustomerOrders/schemas"
import { isSalesOrderEditable } from "@/screens/CustomerOrders/utils"

interface SalesOrderFormLinesProps {
  salesOrder: SalesOrder
}

export const SalesOrderFormLines: FC<SalesOrderFormLinesProps> = ({ salesOrder }) => {
  const { control } = useFormContext<SalesOrderLogisticsFormValues>()
  const { fields } = useFieldArray({ control, name: "lines" })

  return (
    <Box className='flex flex-col gap-4'>
      {fields.map((field, index) => (
        <Fragment key={field.id}>
          {index > 0 && <Divider />}
          <SalesOrderLine
            index={index}
            cpoNumber={salesOrder.lines[index].customerPurchaseOrder.cpoNumber}
            product={salesOrder.lines[index].product}
            readOnly={!isSalesOrderEditable(salesOrder.status)}
          />
        </Fragment>
      ))}
      <SalesOrderTotals salesOrder={salesOrder} />
    </Box>
  )
}
